import whatsappLightLogo from '../../resources/images/whatsapp light .webp';
import {} from './whatsappContact.css';

export function WhatsappContact() {
  return (
    <>
        <a className='App-link' href='https://wa.me/558588225606?text=Ol%C3%A1!%20Gostaria%20de%20saber%20um%20pouco%20mais%20sobre%20seus%20produtos%20de%20aromaterapia.
'
        target='_blank' rel="noopener noreferrer">
          <img src={whatsappLightLogo} className='whatsappLogo' alt="whatsapp logo" />
        </a>
  </>);
}